import * as Sentry from "@sentry/react";
import { useEffect, useRef } from "react"; // Adjust import based on Sentry setup

let isSentryInitialized = false;

function useInitializeSentry(
    sentryEndpointUrl: string,
    tracePropagationTargets: string,
    tracePropagationRegeEx: string,
) {
    const isReplayInitialized = useRef(false);

    useEffect(() => {
        if (isSentryInitialized) {
            return;
        }

        const integrations = [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()];

        if (!isSentryInitialized) {
            integrations.push(
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
            );
            isReplayInitialized.current = true;
        }

        Sentry.init({
            dsn: sentryEndpointUrl,
            integrations,
            tracePropagationTargets: [tracePropagationTargets, `/^${tracePropagationRegeEx}/`],
            tracesSampleRate: 1.0,
            profilesSampleRate: 1.0,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 0.1,
        });
        isSentryInitialized = true;
        console.log(integrations, "intergrato");
    }, []);
}

export default useInitializeSentry;
